import type { ConfigConstructor } from './lib/openable';

import Openable from './lib/openable';

export default class extends Openable {
  constructor(element: HTMLElement, options?: ConfigConstructor) {
    super(element, {
      ...options,
      ...{
        close: {
          escape: true,
          clickOutside: false,
        },
      },
    });
  }

  protected getActiveClass() {
    return 'full-modal--active';
  }
}
